<template>
    <div>
        <div class="page-header">
            <h3>{{ $t('templates') }}</h3>
            <router-link :to="{name : 'admin.templates.create'}" class="btn btn-success">
                <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_template') }}
            </router-link>
        </div>
                
        <grid 
            :data="templates"
            :columns="columns"
            v-on:update-data="fetchData"
            v-on:row-clicked="goToEdit"
            edit-route="/admin/templates"
            delete-route="/api/template"
            with-edit
            with-delete>
        </grid>
    </div>
</template>

<script>
import axios from 'axios'
import Grid from '~/components/Grid'

export default{
    components:{
        Grid
    },
    data(){
        return {
            templates: [],
            columns: [
                {'col':'name','title':'Namn'},
                {'col':'description','title':'Beskrivning'},
                {'col':'printable_type.name','title':'Trycksakstyp'}
            ]
        }
    },
    created(){
        this.fetchData();
    },
    methods : {
        goToEdit(entry){
            this.$router.push("/admin/templates/" + entry.id)
        },
        async fetchData(){
            const { data } = await axios.get('/api/template');
            this.templates = data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/templates/index.vue